import { render, staticRenderFns } from "./HighlightVideoPlayer.vue?vue&type=template&id=f2167880&scoped=true&"
import script from "./HighlightVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./HighlightVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./HighlightVideoPlayer.vue?vue&type=style&index=0&id=f2167880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2167880",
  null
  
)

export default component.exports